'use client';

import { useRouter } from 'next/navigation';
import styles from './Blog.module.scss';
import HeroText from '@/components/HeroText/HeroText';
import PostsList from './PostsList/PostsList';
import { PostType } from './PostCard/PostCard';

type BlogProps = {
  content: PostType[];
  page: {
    title: string;
  };
  pagination: {
    page: number;
    pageCount: number;
    pageSize: number;
    total: number;
  }
};

const Blog = ({ data, locale }: { data: BlogProps; locale: string }) => {
  const router = useRouter();

  const handleURLChange = (page: number) => {
    router.push(`/${locale}/blog?page=${page}`);
  };

  return (
    <>
      <HeroText
        data={{
          title: data.page.title,
        }}
        className={styles.hero}
      />
      <PostsList
        posts={data.content}
        pagination={data.pagination}
        onPageChange={handleURLChange}
      />
    </>
  );
};

export default Blog;
